export class MerchantConsumerPortalFeeSettings {
	feesEnabled: boolean;
	allowFeesOnPaymentPlans: boolean;
	allowServiceFeesOnEveryTransaction: boolean;
}
